import axios from 'modules/api-client/request';
import { handleAmazonMessage } from 'modules/api-client/response';

import type { IMetaResponse } from '../types';
import {
  ICourseReservation,
  ICourseReservationRequest,
  ICourseReservationMeta,
  ICourseReservationFilter,
  IExportedFile,
} from './types';

export const getCourseReservationRequest = ({ courseId, ...params }: ICourseReservationRequest) => {
  return axios
    .get<
      ICourseReservationRequest,
      IMetaResponse<ICourseReservation[], ICourseReservationMeta>
    >(`/admin/courses/${courseId}/bookings`, { params })
    .catch(handleAmazonMessage);
};

export const cancelCourseReservationRequest = (courseId: string, bookingId: string) => {
  return axios.post<void, void>(`admin/courses/${courseId}/booking/${bookingId}/cancel`).catch(handleAmazonMessage);
};

export const getExportedReservationsFilesRequest = (courseId: string) => {
  return axios.get<void, IExportedFile[]>(`/admin/courses/${courseId}/bookings/export`).catch(handleAmazonMessage);
};

export const triggerReservationsExportRequest = (courseId: string, filters: ICourseReservationFilter) => {
  return axios
    .get(`/admin/courses/${courseId}/bookings/export`, {
      params: { export: true, ...filters },
    })
    .catch(handleAmazonMessage);
};

